<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService"
                @click="ClearData()">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AssignPosition"
                @click="ClearData()">ขอแต่งตั้งตำแหน่ง (หน่วยดำเนินการ)</router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AssignPosition" @click="ClearData()">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AssignPosition" @click="ClearData()">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            ">
            ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <div class="blue-1 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ขอแต่งตั้งตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)
              <img src="@/assets/images/checked.svg" class="svg-checked" />
            </div>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <label class="gary-3 fs-5 font-family">ตัวแทนใต้สังกัดที่ต้องการดำเนินการ</label>
          </div>
          <div class="ps-5 gary-3 fs-5 font-family">
            <div>รหัส {{ this.$store.state.PASS_ASSIGN_POSITION.NAME }}</div>
            <div>ตำแหน่งปัจจุบัน {{ this.$store.state.PASS_ASSIGN_POSITION.TITLE }}</div>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <label class="gary-3 fs-5 font-family">ตำแหน่งใหม่ : {{ this.$store.state.PASS_ASSIGN_POSITION.CHG_POT }}
            </label>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <label class="gary-3 fs-5 font-family text-break">ประสบการณ์ในธุรกิจประกันชีวิต : {{
              this.$store.state.PASS_ASSIGN_POSITION.MEMO1 }}
            </label>
          </div>
        </div>
        <div class="pb-2 pb-lg-2 border-bottom">
          <div class="ps-3 mt-2 mt-lg-2">
            <label class="gary-3 fs-5 font-family text-break">ข้อมูลเพิ่มเติม : {{
              this.$store.state.PASS_ASSIGN_POSITION.MEMO2 }}
            </label>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <div class="blue-1 fs-5 font-family">
              กรุณาตรวจสอบข้อมูลที่ขอแก้ไขก่อนกดปุ่ม ส่งข้อมูล
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <!-- <button v-if="this.$store.state.ASSIGN_POSITION.EXP_DETAIL != ''" type="button" class="btn btn-continue font-family d-inline-block" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
              แนบเอกสาร
            </button>
            <button v-else type="button" class="btn btn-continue font-family d-inline-block" @click="submit()">
              ส่งข้อมูล
            </button> -->
            <button type="button" class="btn btn-continue font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#staticBackdrop">
              แนบเอกสาร
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel " data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AssignPosition">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-family">
        <div class="modal-header">
          <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
            กรุณาแนบหลักฐาน
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click="ClearFile()"></button>
        </div>
        <div class="modal-body fw-normal fs-5">
          <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงรายการข้อมูลดังนี้</div>
          <div class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer" />{{ DETAIL_MODAL[0].HEADER }}
          </div>
          <div>
            <label>กรุณากด</label><label
              class="blue-1 ps-1 pe-1">"แนบไฟล์"</label><label>เพื่อแนบหลักฐานการเปลี่ยนแปลงดังต่อไปนี้</label>
          </div>
          <div class="ps-2">
            <div v-for="(items, index) in DETAIL_MODAL[0].DETAIL" :key="index">
              <div v-if="items.DEFAULT_FLG == 'Y'">
                <label>{{ items.HEADER_DESCRIPTION }}</label>
                <ul>
                  <li v-for="(item, index) in items.SUB_DETAIL" :key="index" class="ps-2 blue-1">{{ item.DESCRIPTION }}
                  </li>
                </ul>
              </div>
              <div v-else-if="items.DEFAULT_FLG == 'N' && $store.state.ASSIGN_POSITION.EXP_DETAIL != ''">
                <label>{{ items.HEADER_DESCRIPTION }}</label>
                <ul>
                  <li v-for="(item, index) in items.SUB_DETAIL" :key="index" class="ps-2 blue-1">{{ item.DESCRIPTION }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <label>(ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน 4 MB)</label>
          </div>

          <div class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ บันทึกการขอแต่งตั้งตำแหน่ง
                โดยผ่านความเห็นชอบกับผู้ที่เกี่ยวข้อง</label>
              <button type="button" class="border-0 bg-light" @click="FileImport($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="uploader" style="display: none" @change="onFileChange($event)" />
            </div>

            <div v-if="this.UploadFile != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ File.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFile()" />
            </div>
          </div>

          <div class="shadow-none p-3 mb-1 bg-light rounded" v-if="$store.state.ASSIGN_POSITION.EXP_DETAIL != ''">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ หลักฐานแสดงว่ามีประสบการณ์ในธุรกิจประกันชีวิต มาจากบริษัท</label>
              <button type="button" class="border-0 bg-light" @click="FileImport2($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="uploader2" style="display: none" @change="onFileChange2($event)" />
            </div>

            <div v-if="this.UploadFile2 != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ File2.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFile2()" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary fs-5" data-bs-dismiss="modal" @click="ClearFile()">
            แก้ไข
          </button>
          <button type="button" class="btn btn-primary fs-5" data-bs-dismiss="modal" @click="CheckEnter()">
            ส่งข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "FinishAssignPosition",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      faCircleXmark: faCircleXmark,
      Loading: false,
      UploadFile: null,
      File: '',
      UploadFile2: null,
      File2: '',
      DETAIL_MODAL: [
        {
          SUBJOB: '',
          HEADER: '',
          DETAIL: [
            {
              HEADER_DESCRIPTION: '',
              SUB_DETAIL: [],
              DEFAULT_FLG: ''
            }
          ],
        }
      ],
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
    this.GetDetailFile();
  },
  methods: {
    FileImport(e) {
      this.$refs.uploader.click();
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFile = files[0];
        if (this.UploadFile != undefined || this.UploadFile != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.ASSIGN_POSITION.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFile);

          this.$store.state.ASSIGN_POSITION.FILE.FILE_TYPE = this.UploadFile.type;
          this.File = this.UploadFile;
        }
      }
    },
    DelectFile() {
      this.UploadFile = null;
      this.File = '';
      this.$store.state.ASSIGN_POSITION.FILE.FILE = '';
      this.$store.state.ASSIGN_POSITION.FILE.FILE_TYPE = '';

      this.$refs.uploader.value = null;
    },
    FileImport2(e) {
      this.$refs.uploader2.click();
    },
    onFileChange2(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFile2 = files[0];
        if (this.UploadFile2 != undefined || this.UploadFile2 != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.ASSIGN_POSITION.FILE_EXP_DETAIL.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFile2);

          this.$store.state.ASSIGN_POSITION.FILE_EXP_DETAIL.FILE_TYPE = this.UploadFile2.type;
          this.File2 = this.UploadFile2;
        }
      }
    },
    DelectFile2() {
      this.UploadFile2 = null;
      this.File2 = '';
      this.$store.state.ASSIGN_POSITION.FILE_EXP_DETAIL.FILE = '';
      this.$store.state.ASSIGN_POSITION.FILE_EXP_DETAIL.FILE_TYPE = '';

      this.$refs.uploader2.value = null;
    },
    ClearData() {
      this.$store.state.PASS_ASSIGN_POSITION.NAME = '';
      this.$store.state.PASS_ASSIGN_POSITION.TITLE = '';
      this.$store.state.PASS_ASSIGN_POSITION.CHG_POT = '';
      this.$store.state.PASS_ASSIGN_POSITION.MEMO1 = '';
      this.$store.state.PASS_ASSIGN_POSITION.MEMO2 = '';

      this.$store.state.ASSIGN_POSITION.AGENTCODE_PROMOTE = '';
      this.$store.state.ASSIGN_POSITION.EXP_DETAIL = '';
      this.$store.state.ASSIGN_POSITION.AD_INFO_DETAIL = '';
      this.$store.state.ASSIGN_POSITION.AG_POSITION_ID = '';

      this.$store.state.ASSIGN_POSITION.FILE.FILE = '';
      this.$store.state.ASSIGN_POSITION.FILE.FILE_TYPE = '';
    },
    ClearFile() {
      this.$store.state.ASSIGN_POSITION.FILE.FILE = '';
      this.$store.state.ASSIGN_POSITION.FILE.FILE_TYPE = '';
    },
    CheckEnter() {
      this.Loading = true;
      if (this.$store.state.ASSIGN_POSITION.FILE.FILE === '') {
        this.Loading = false;
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ บันทึกการขอแต่งตั้งตำแหน่ง โดยผ่านความเห็นชอบกับผู้ที่เกี่ยวข้อง</label>',
        });
      }
      else if (this.$store.state.ASSIGN_POSITION.EXP_DETAIL !== '' && this.$store.state.ASSIGN_POSITION.FILE_EXP_DETAIL.FILE === '') {
        this.Loading = false;
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ หลักฐานแสดงว่ามีประสบการณ์ในธุรกิจประกันชีวิต</label>',
        });
      }
      else {
        this.$store.state.ASSIGN_POSITION.AGENTCODE = this.$store.state.AgentCode;

        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");

        http.post("AgencyERequest/SetAgentPosition", this.$store.state.ASSIGN_POSITION, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.status == 200) {
            this.Loading = false;
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'ส่งข้อมูลสำเร็จ',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.ClearData();
              // this.$router.push('/FinishAgentInfoView');

              this.$router.push({
                path: '/FinishAgentInfoView',
                query: { tel: '8567' }
              });
            });
          }
          else {
            this.Loading = false;
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
            });
          }
        }).catch((error) => {
          this.Loading = false;
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
          });
        });
      }
    },
    submit() {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");

      // http.post("AgencyERequest/SetAgentPosition", this.$store.state.ASSIGN_POSITION, { headers: { Authorization: `Bearer ${AuthorizeToken}` }}).then((res) => { 
      //   if(res.status == 200) {
      //     this.Loading = false;
      //     Swal.fire({
      //       position: 'center',
      //       icon: 'success',
      //       title: 'ส่งข้อมูลสำเร็จ',
      //       showConfirmButton: false,
      //       timer: 1500
      //     }).then(() => {
      //       this.ClearData();
      //       this.$router.push('/FinishAgentInfoView');
      //     });
      //   }
      //   else { 
      //     this.Loading = false;
      //     Swal.fire({
      //       icon: 'error',
      //       html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
      //     });
      //   }
      // }).catch((error) => {
      //   this.Loading = false;
      //   Swal.fire({
      //     icon: 'error',
      //     html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
      //   });
      // });
    },
    ValidateFileType(Type) {
      if (Type !== "image/png" && Type !== "image/jpeg" && Type !== "application/pdf" && Type !== "image/jpg") {
        this.ClearFile();
        return false;
      }
      else {
        return true;
      }
    },
    GetDetailFile() {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");

      let ArraySubJob = [this.$store.state.ASSIGN_POSITION.SUBJOB];
      let params = { SUBJOB: ArraySubJob, };

      this.Loading = true;
      http.post("AgencyERequest/GetDetailModalFile?", params, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
        if (response.status == 200) {
          this.DETAIL_MODAL = [];
          response.data.forEach(item => {
            this.DETAIL_MODAL.push(item);
          });
          this.Loading = false;
        }

      }).catch(() => { this.Loading = false; });
    }
  },
};
</script>

<style></style>